// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2e6kx","tab":"Tabs_tab__3A405","tabActive":"Tabs_tabActive__dlzu7"};